import { Typography } from "antd";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import GraiaIcon from "../../assets/GraiaIcon.tsx";
import environmentConfig from "../../environmentConfig";

export interface HeaderProps {
  conversationId: string;
}

export default function Header({ conversationId }: HeaderProps): ReactElement {
  const { t } = useTranslation();

  return (
    <HeaderBox>
      <LogoAndTitleBox>
        <Logo aria-label="Graia" />
        <Title>{t("appName")}</Title>
      </LogoAndTitleBox>
      {
        environmentConfig.environment !== "prod" &&
        <Typography.Text code copyable={{ tooltips: ["", ""] }} style={{ color: "inherit", textAlign: "right" }}>
          {conversationId}
        </Typography.Text>
      }
    </HeaderBox>
  );
}

const HeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${p => p.theme.paddingSM}px;
  justify-content: space-between;
  align-items: center;
`;

const LogoAndTitleBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${p => p.theme.paddingSM}px;
  align-items: center;
`;

const Logo = styled(GraiaIcon)`
  width: ${p => p.theme.fontSizeHeading3}px;
  height: ${p => p.theme.fontSizeHeading3}px;
`;

const Title = styled(Typography.Title).attrs({ level: 1 })`
  &&& {
    margin: 0;
    font-weight: normal;
    font-size: ${p => p.theme.fontSizeHeading4}px;
    user-select: none; 
  }
`;
